<app-info-page
  title="Bienvenido"
  [subtitle]="'Hola, soy ' + owner + ', tu anfitrión'"
  [videoSrc]="videoSrc"
  [imageSrc]="imageSrc"
>
  <p class="info-card__text"  [innerHTML]="welcome_text"></p>
</app-info-page>
